import React from "react";
/** Components Import */
import {
	Stack,
	TextField,
	Typography,
} from "@mui/material";

function FindPw(props) {
	return (
		<>
			{props.findPwInputs.successful ? (
				<Stack sx={{ my: 2 }} spacing={2}>
					<TextField
						sx={{ minWidth: 280 }}
						type="password"
						label={
							props.lanList.length > 0
								? props.lanList.filter(
									(f) => f.lanId === "Password"
								)[0].lanNm
								: "" // Password
						}
						value={props.findPwInputs.userPw}
						onChange={(e) => {
							props.setFindPwInputs({
								...props.findPwInputs,
								userPw: e.target.value,
							});
						}}
					/>
					<TextField
						sx={{ minWidth: 280 }}
						type="password"
						label={
							props.lanList.length > 0
								? props.lanList.filter(
									(f) => f.lanId === "PasswordConfirm"
								)[0].lanNm
								: "" // Password 확인
						}
						value={props.findPwInputs.userPwConfirm}
						onChange={(e) => {
							props.setFindPwInputs({
								...props.findPwInputs,
								userPwConfirm: e.target.value,
							});
						}}
					/>
					<Typography variant="caption">
						{`(8자리 이상, 대문자, 숫자, 특수문자(!@#$%^&*)가 포함되어야합니다.)`}
					</Typography>
					<Typography textAlign="right" color="red">
						{(props.findPwInputs.userPw !== "" ||
							props.findPwInputs.userPwConfirm !== "") &&
							props.findPwInputs.userPw !== props.findPwInputs.userPwConfirm
							? "비밀번호가 다릅니다."
							: null}
					</Typography>
				</Stack>
			) : (
				<Stack sx={{ my: 2 }} spacing={2}>
					<TextField
						sx={{ minWidth: 280 }}
						label={
							props.lanList.length > 0
								? props.lanList.filter(
									(f) => f.lanId === "Id"
								)[0].lanNm
								: "" // ID
						}
						value={props.findPwInputs.userId}
						onChange={(e) => {
							props.setFindPwInputs({
								...props.findPwInputs,
								userId: e.target.value,
							});
						}}
					/>
					<TextField
						sx={{ minWidth: 280 }}
						label={
							props.lanList.length > 0
								? props.lanList.filter(
									(f) => f.lanId === "Name"
								)[0].lanNm
								: "" // 이름
						}
						value={props.findPwInputs.userNm}
						onChange={(e) => {
							props.setFindPwInputs({
								...props.findPwInputs,
								userNm: e.target.value,
							});
						}}
					/>
					<TextField
						sx={{ minWidth: 280 }}
						label={
							props.lanList.length > 0
								? props.lanList.filter(
									(f) => f.lanId === "Tel"
								)[0].lanNm
								: "" // 전화번호
						}
						value={props.findPwInputs.userTel}
						type="tel"
						onChange={(e) => {
							props.setFindPwInputs({
								...props.findPwInputs,
								userTel: e.target.value
									.replace(/[^0-9]/g, "")
									.replace(
										/^(\d{0,3})(\d{0,4})(\d{0,4})$/g,
										"$1-$2-$3"
									)
									.replace(/(\-{1,2})$/g, ""),
							});
						}}
					/>
				</Stack>
			)}
		</>
	);
}

export default FindPw;
